import { EditableTaskFormState } from '@/client/admin-tasks';
import { EditableTaskCard } from '@/components/admin-tasks/EditableTaskCard';
import { useSortableItem } from '@/hooks/useSortableItem';
import { DragHandleIcon } from '@/utils/helpers';
import React from 'react';
import styled from 'styled-components';

const SortableItemWrapper = styled.div`
  position: relative;
  width: 100%;

  &:active {
    cursor: grabbing;
  }
`;

const DragHandle = styled.div`
  position: absolute;
  top: 50%;
  left: var(--small-padding);
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  color: var(--gray-darker);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;

  ${SortableItemWrapper}:hover & {
    opacity: 1;
  }

  &:active {
    cursor: grabbing;
  }
`;

const CardContent = styled.div`
  padding-inline: var(--big-padding);
`;

export interface SortableTaskItemProps {
  initialValues: EditableTaskFormState;
  onValuesChange: (values: EditableTaskFormState) => void;
  onDelete?: () => void;
  style?: React.CSSProperties;
}

export const SortableTaskItem: React.FC<SortableTaskItemProps> = ({
  initialValues,
  onValuesChange,
  onDelete,
  style: externalStyle,
}) => {
  const { setNodeRef, dragHandleProps, style } = useSortableItem({
    id: initialValues.taskId,
    style: {
      ...externalStyle,
      position: 'relative',
      width: '100%',
    },
  });

  return (
    <SortableItemWrapper ref={setNodeRef} style={style}>
      <DragHandle {...dragHandleProps}>
        <DragHandleIcon />
      </DragHandle>
      <CardContent>
        <EditableTaskCard
          initialValues={initialValues}
          onValuesChange={onValuesChange}
          onDelete={onDelete}
        />
      </CardContent>
    </SortableItemWrapper>
  );
};
